import React from 'react'
import {
  Text as UIFoundationsText,
  Container as UIFoundationsContainer,
  Dialog as UIFoundationsDialog,
  DialogMaxWidthSizes,
  IconButtonStyles,
  ContainerPaddings,
  ButtonProps,
  useThemeUtils
} from '@dcxwam/dcx-wam-ui-foundations'

export type ErrorMessageContent = {
  message?: string | null
  title?: string | null
  actions?: Array<ButtonProps> | null
  dismissible?: boolean
}

interface CartErrorMessageDialogProps {
  errorMessageContent?: ErrorMessageContent
  dialogErrorMessageIsOpen: boolean
  setDialogErrorMessageIsOpen: (open: boolean) => void
}

const CartErrorMessageDialog: React.FC<CartErrorMessageDialogProps> = (
  props
) => {
  const {
    errorMessageContent,
    dialogErrorMessageIsOpen,
    setDialogErrorMessageIsOpen
  } = props

  const themeUtils = useThemeUtils()

  const errorDialogProps = {
    id: 'error-message-add-to-cart',
    onClose: () => setDialogErrorMessageIsOpen(false),
    zIndex: 1351, // used same as for sag,
    ...(errorMessageContent?.title !== null
      ? { title: errorMessageContent?.title }
      : {}),
    ...(errorMessageContent?.actions && errorMessageContent?.actions !== null
      ? {
          actions: errorMessageContent?.actions,
          dismissible: errorMessageContent?.dismissible
        }
      : { dismissible: true }),
    maxWidth: DialogMaxWidthSizes.SM,
    fullWidth: true,
    dialogContentPadding: false,
    closeButtonStyle: IconButtonStyles.Default
  }

  const configContainerErrorMessage = {
    ...(errorMessageContent?.message === null
      ? {
          padding: themeUtils.getResponsiveProp([
            {
              t: ContainerPaddings.Size_5
            }
          ])
        }
      : { padding: ContainerPaddings.Size_5 })
  }
  return (
    <UIFoundationsDialog
      {...{
        isOpen: dialogErrorMessageIsOpen,
        ...errorDialogProps
      }}
    >
      <UIFoundationsContainer {...configContainerErrorMessage}>
        <UIFoundationsText.TextSection>
          <UIFoundationsText content={errorMessageContent?.message || ''} />
        </UIFoundationsText.TextSection>
      </UIFoundationsContainer>
    </UIFoundationsDialog>
  )
}
export default CartErrorMessageDialog
